import { CoeOrderBuyEntity, CoeOfferEntity } from '@genial/services';
import { Utils } from '@genial/utils';

import { RiskRating } from '../../../../../../../../components/RiskRating';
import { notificationChannelsData } from '../../../../../../../Resume/utils';
import { TicketApplicationBaseInfoProps } from '../../components/TicketApplicationSuccessDetails';

export const getCoesSuccessInfos = (
  offer: CoeOfferEntity,
  order: CoeOrderBuyEntity,
  showSendingChannels: boolean,
  hideDateTimeFieldsOnProverOrigin: boolean
): TicketApplicationBaseInfoProps => {
  const orderHash = order.orderHash || order.orderId || '--';
  const orderName = order.orderName;

  const orderNameFormatted = orderName && orderHash ? `${orderName} - ${orderHash}` : '--';

  const orderChannels = notificationChannelsData({ order });

  const hasOrderOrigin = !!order?.interactionChannelAuditDetail as boolean;

  const productDetails = [
    { label: 'Operação', value: `${offer.fantasyName} ${offer.asset}` },
    { label: 'Estratégia', value: offer.strategy || '--' },
    {
      label: 'Risco',
      value: (
        <RiskRating
          currentRiskRating={Number(offer.suitabilityProductRisk.scoreAdjusted) || 0}
          tooltip={offer.suitabilityProductRisk.risk || ''}
        />
      ),
    },
    { label: 'Vencimento', value: Utils.Mask.DateFormat(offer.maturityDate, 'dd/MM/yyyy') || '--' },
    { label: 'Aplicação em', value: offer.applicationIn || '--' },
    { label: 'Aplicação mínima', value: Utils.Mask.Money(offer.minimumApplication) },
    { label: 'Tipo de boletagem', value: order.billingType.billingDescription || '--' },
    { label: 'Valor aplicado', value: Utils.Mask.Money(order.orderAmount) },
  ];

  const solicitationDate = order.interactionChannelAuditDetail?.interactionChannelDate;

  const channelDetails = [
    {
      label: 'Canal de solicitação',
      value: order.interactionChannelAuditDetail?.interactionChannelOption.channel || '--',
    },
  ];

  if (!hideDateTimeFieldsOnProverOrigin) {
    channelDetails.push(
      {
        label: 'Data de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'dd/MM/yyyy') : '',
      },
      {
        label: 'Horário de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'HH:mm') : '',
      }
    );
  }

  const orderDetails = [
    { label: 'Nome da ordem', value: orderNameFormatted },
    ...(hasOrderOrigin ? channelDetails : []),
  ];

  if (showSendingChannels) {
    orderDetails.push(
      { label: 'Canal de envio', value: orderChannels || '--' },
      {
        label: 'Hora/data de Envio',
        value: order.orderCreatedAt
          ? Utils.Mask.DateFormat(order.orderCreatedAt, 'dd/MM/yyyy HH:mm:ss')
          : '--',
      }
    );
  }

  return {
    orderHash,
    productDetails,
    orderDetails,
  };
};
